import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import BlogSection from 'components/common/sections/BlogSection';
import TryDemoSection from 'components/common/sections/TryDemoSection';
import BlogHeaderLarge from 'assets/images/blog-header-large.png';
import {LinkedIn, Instagram} from "../../utils/constants";

const WhyZerodha = () => (
  <>
    {/* Blog header section */}
    <section id="blog-header-section" className="mb-2">
      <Container className="mt-5">
        <Row>
          <Col sm={12}>
            <h2>Why Zerodha: Empowering Your investment journey</h2>
            <p>
              Sid Goyal
              <span style={{color: "#00000099", marginLeft: "20px"}}>05 OCT 2023</span>
              <a href={LinkedIn} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin" style={{color: "#301E67", marginLeft: "20px"}}></i>
              </a>
              <a href={Instagram} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram" style={{color: "#301E67", marginLeft: "20px"}}></i>
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog Image Section */}
    <section id="blog-image-section" className="mb-3 mt-5 mt-lg-0">
      <Container fluid className="mt-2 px-0">
        <Row>
          <Col sm={12} className="text-center px-0 mb-2 mb-lg-4">
            <img className="img-fluid" src={BlogHeaderLarge} alt=""/>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog Content section */}
    <section id="blog-content-section">
      <Container className="mt-3">
        <Row className="d-flex justify-content-center">
          <Col sm={12} lg={10} xl={8}
               className="d-flex align-items-center text-left mt-3 mt-lg-0 ps-2 ps-lg-5 bg-white">
            <div>
              <p style={{color: "#000000cc"}}>
                When it comes to managing your finances and investments, the choice of a reliable brokerage platform
                plays a pivotal role. <strong>Zerodha</strong> is a name that stands out in the world of financial
                services
                in India.
                <br/>
                If you're seeking a partner to empower your investment journey, here's why you should consider Zerodha.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>1. User-Friendly Interface</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Zerodha offers a user-friendly and intuitive interface. Whether you're a beginner or an experienced
                trader,
                their platform is designed to provide a seamless and efficient trading experience.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>2. Low Brokerage Fees</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Zerodha is known for its low brokerage fees, making it a cost-effective choice for investors. You can
                keep
                more of your earnings and reduce your trading costs significantly.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>3. Advanced Tools</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Zerodha provides traders with advanced tools and analytics. From charting to advanced automation,
                their platform equips you with the necessary resources to be your broker on your investment journey.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>4. Robust Customer Support</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Zerodha offers excellent customer support to assist you at every step of your investment journey.
                Whether
                you have questions or need assistance, their dedicated support team is there to help.
              </p>
              <div>
                <h2 style={{paddingTop: 10}}>5. Transparency and Trust</h2>
              </div>
              <p style={{color: "#000000cc"}}>
                Zerodha values transparency and trust. They prioritize the security of your financial data and adhere to
                strict regulatory standards, ensuring a safe and reliable trading environment.
              </p>
              <p style={{color: "#000000cc", paddingTop: 10}}>
                In conclusion, Zerodha is your partner in empowering your investment journey. With a user-friendly
                interface,
                low brokerage fees, advanced tools, robust customer support, and a commitment to transparency and trust,
                Zerodha helps you take control of your finances and reach your financial goals.
              </p>
              <p style={{color: "#000000cc", paddingTop: 10}}>
                Start your investment journey with Zerodha today and experience the difference.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    {/* End */}

    {/* Blog section 2 */}
    <BlogSection/>

    {/* Try CTA section */}
    <TryDemoSection/>
  </>
);

export default WhyZerodha;
